export default {
  fromWidgetToCard: (w) => {
    return {
      term: w.term,
      is_external: w.isExternal || w.is_external,
      external_url: w.externalUrl || w.is_external,
      publication_end_date: w.publicationEndDate || w.publication_end_date,
      relativeDates: w.relativeDates,

      ru: {
        background_image: w.backgroundImageRu || w.ru?.background_image,
        background_image_mobile: w.backgroundImageMobileRu || w.ru?.background_image_mobile,
        title: w.titleRu || w.ru?.title,
        text: w.textRu || w.ru?.text,
      },

      ua: {
        background_image: w.backgroundImageUa || w.ua?.background_image,
        background_image_mobile: w.backgroundImageMobileUa || w.ua?.background_image_mobile,
        title: w.titleUa || w.ua?.title,
        text: w.textUa || w.ua?.text,
      },
    }
  },
}
